import(/* webpackMode: "eager" */ "/vercel/path1/app/components/auth/registration.tsx");
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path1/public/kc_logo_white_plus.png")